import * as React from 'react';
import { NavLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import { roleContext } from '../../context/RoleContext';
import { useContext } from 'react';
import { UserRole } from '../../types/role';

const ProfileNav = () => {
  const role = useContext(roleContext);
  const isActiveStyle = {
    fontWeight: 'bold',
    backgroundColor: '',
    padding: '8px 0',
    borderBottom: 'solid 2px #DD8709',
  };
  return (
    <Box
      className="profileNav"
      sx={{
        ml: 0,
        mt: 0.5,
        backgroundColor: 'rgb(215, 167, 72,20%)',
        position: 'relative',
        bottom: '4px',
        padding: '0 15px !important',
        borderBottom: '#d3d3d3 solid 1px !important ',
      }}
    >
      <Box
        className="profileNavLink"
        sx={{
          display: 'flex',
          alignItems: 'center',
          ml: '25%',
          justifyContent: 'center',
          mx: 'auto',
        }}
      >
        <NavLink
          to={'/services'}
          className="nav-link"
          style={({ isActive }) =>
            isActive ? { ...isActiveStyle } : undefined
          }
        >
          <MenuItem
            className="menu"
            sx={{ textAlign: 'center', color: 'rgba(0, 0, 0, 1)' }}
          >
            <WorkOutlineIcon className="profileNavIcon" fontSize="small" />{' '}
            <Box
              style={{
                fontWeight: 'bold',
                fontSize: '14px',
                fontFamily: 'GFS Didot',
              }}
              className="profileNavv"
            >
              Services
            </Box>
          </MenuItem>
        </NavLink>
        {role !== UserRole.SHOP_OWNER && (
          <NavLink
            to={'/business-hours'}
            className="nav-link"
            style={({ isActive }) =>
              isActive ? { ...isActiveStyle } : undefined
            }
          >
            <MenuItem
              className="menu"
              sx={{ textAlign: 'center', color: 'rgba(0, 0, 0, 1)' }}
            >
              <AccessTimeOutlinedIcon
                className="profileNavIcon"
                fontSize="small"
              />{' '}
              <Box
                style={{
                  fontWeight: 'bold',
                  fontSize: '14px',
                  fontFamily: 'GFS Didot',
                }}
                className="profileNavv"
              >
                Business Hours
              </Box>
            </MenuItem>
          </NavLink>
        )}
        {role === UserRole.SHOP_OWNER && (
          <NavLink
            to={'/barbers'}
            className="nav-link"
            style={({ isActive }) =>
              isActive ? { ...isActiveStyle } : undefined
            }
          >
            <MenuItem sx={{ textAlign: 'center', color: 'rgba(0, 0, 0, 1)' }}>
              <GroupsOutlinedIcon
                fontSize="small"
                className="profileNavIcon"
                sx={{
                  color: 'rgba(0, 0, 0, 1)',

                  width: '20px',
                  height: '20px',
                }}
              />{' '}
              <Box
                style={{
                  marginLeft: '5px',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  fontFamily: 'GFS Didot',
                }}
                className="profileNavv "
              >
                All Barbers
              </Box>
            </MenuItem>
          </NavLink>
        )}

        {role !== UserRole.SHOP_BARBER && (
          <NavLink
            to={'/my-gallery'}
            className="nav-link"
            style={({ isActive }) =>
              isActive ? { ...isActiveStyle } : undefined
            }
          >
            <MenuItem
              className="menu"
              sx={{ textAlign: 'center', color: 'rgba(0, 0, 0, 1)' }}
            >
              <CollectionsOutlinedIcon
                className="profileNavIcon"
                fontSize="small"
              />{' '}
              <Box
                style={{
                  marginLeft: '5px',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  fontFamily: 'GFS Didot',
                }}
                className="profileNavv"
              >
                Gallery
              </Box>
            </MenuItem>
          </NavLink>
        )}

        {role === UserRole.SHOP_OWNER && (
          <NavLink
            to={'/Amenities'}
            className="nav-link"
            style={({ isActive }) =>
              isActive ? { ...isActiveStyle } : undefined
            }
          >
            <MenuItem sx={{ textAlign: 'center', color: 'rgba(0, 0, 0, 1)' }}>
              <ListAltOutlinedIcon
                fontSize="small"
                className="profileNavIcon"
                sx={{
                  color: 'rgba(0, 0, 0, 1)',

                  width: '20px',
                  height: '20px',
                }}
              />{' '}
              <Box
                style={{
                  marginLeft: '5px',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  fontFamily: 'GFS Didot',
                }}
                className="profileNavv "
              >
                Amenities
              </Box>
            </MenuItem>
          </NavLink>
        )}
      </Box>
    </Box>
  );
};

export default ProfileNav;
